"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openKeyboard = exports.closeKeyboard = void 0;
var _types = require("./types");
// ====================================================================
// Typed actions
// ====================================================================

var open = function open() {
  return {
    type: _types.KEYBOARD.OPEN
  };
};
var close = function close() {
  return {
    type: _types.KEYBOARD.CLOSE
  };
};

// ====================================================================
// Functions actions
// ====================================================================

var openKeyboard = exports.openKeyboard = function openKeyboard() {
  return function (dispatch) {
    dispatch(open());
  };
};
var closeKeyboard = exports.closeKeyboard = function closeKeyboard() {
  return function (dispatch) {
    dispatch(close());
  };
};